import { FormTextEditor } from '@Components/Form';
import { disabledFormInputStyles } from '@Components/Form/styles';
import { MarketingIndustryFormValues } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';
import { useWatch } from 'react-hook-form';

type LastYearMarketPoliciesFormFieldsProps = {
  marketPolicyIndex: number;
};

const LastYearMarketPoliciesFormFields = ({
  marketPolicyIndex: index,
}: LastYearMarketPoliciesFormFieldsProps) => {
  const { completedSection } =
    useWatch({ name: 'marketingIndustry' }) ??
    ({} as MarketingIndustryFormValues);

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  return (
    <>
      <FormTextEditor
        name={`marketingIndustry.marketingPolicy.${index}.descriptionTh`}
        label={
          'กรุณาอธิบายนโยบายการตลาดของผลิตภัณฑ์หรือบริการที่สำคัญในปีที่ผ่านมา (ไทย)'
        }
        inputProps={{ placeholder: 'กรุณาระบุ (ไทย)' }}
        required
        sx={isCompletedTh ? disabledFormInputStyles : {}}
      />
      <FormTextEditor
        name={`marketingIndustry.marketingPolicy.${index}.descriptionEn`}
        label={
          'กรุณาอธิบายนโยบายการตลาดของผลิตภัณฑ์หรือบริการที่สำคัญในปีที่ผ่านมา (อังกฤษ)'
        }
        mt={2}
        inputProps={{ placeholder: 'กรุณาระบุ (อังกฤษ)' }}
        required
        sx={isCompletedEn ? disabledFormInputStyles : {}}
      />
    </>
  );
};

export default LastYearMarketPoliciesFormFields;
